// extracted by mini-css-extract-plugin
export var button = "_i6-2";
export var card = "_i6-0";
export var closeButtonContainer = "_i6-3";
export var iconContainer = "_i6-1";